import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Drawer, Spacer } from "@common/AggregationComponent";
import ProductTabFilterDetails from "@common/NewFilter/ProductTabFilter/FilterDetails";
import { getEcRenewalCompatibility } from "@util/common";

const ProductTabNewFilter = (props: any) => {
  const { visible, onClose, total } = props;
  const { t } = useTranslation();
  return (
    <div>
      <Drawer
        closeTitle={"close title"}
        closeLabel={getEcRenewalCompatibility() ? " " : t("text_a11y_close")}
        footer={
          <Button
            element="button"
            variant="primary"
            onClick={() => {
              onClose();
            }}
          >
            {t("text_apply_search_filter")}
          </Button>
        }
        isOpen={visible}
        itemCount={`${t("text_image_search_result_number", { total: total })}`}
        onRequestClose={() => {
          onClose();
        }}
        position="start"
        title={t("text_filter")}
        trapFocus
        variant="fullWidth"
        visible
      >
        <ProductTabFilterDetails {...props} />
        <Spacer element="div" variant="spacing-05" />
      </Drawer>
    </div>
  );
};

export default ProductTabNewFilter;
